import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-2 border-custom-purple text-custom-purple rounded-md py-2" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonSecondary',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _toDisplayString(props.text), 1))
}
}

})